import Navbar from "../components/Navbar";
import AdminForm from "../components/AdminForm";

const Admin = () => {

    return (

        <>

            <Navbar />

            <section
                style={{
                    background: "#07111e",
                    minHeight: "100vh",
                    padding: "140px 0 80px"
                }}
            >

                <div
                    style={{
                        width: "min(900px,90%)",
                        margin: "0 auto"
                    }}
                >

                    <h1
                        style={{
                            color: "#fff",
                            marginBottom: "12px"
                        }}
                    >
                        Blog Admin
                    </h1>

                    <p
                        style={{
                            color: "#9ba7c2",
                            marginBottom: "50px"
                        }}
                    >
                        Publish new blogs to Firebase.
                    </p>

                    <AdminForm />

                </div>

            </section>

        </>

    );

};

export default Admin;